import {Component, Inject, OnInit} from '@angular/core';
import {AttributeDataType, DeviceAttribute} from "../../model/device-attribute.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DeviceService} from "../../device/device.service";

@Component({
    selector: 'app-device-attribute-dialog',
    templateUrl: './device-attribute-dialog.component.html',
    styleUrls: ['./device-attribute-dialog.component.scss'],
    standalone: false
})
export class DeviceAttributeDialogComponent implements OnInit {
  types:any[] = [];
  item: DeviceAttribute;

  constructor(
    private service: DeviceService,
    public dialogRef: MatDialogRef<DeviceAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.initDialog();
  }

  initDialog() {
    this.item = this.data.item;

    Object.entries(AttributeDataType).map(([key, value]:[any,any]) => {
      this.types.push({
        id: value,
        name: key
      })
    })
  }

  handleResponse(resp) {
    if (resp && resp.id) {
      this.service.notiService.open("Mentve.");
      this.dialogRef.close(new DeviceAttribute(resp));
    } else {
      const msg = resp.error ? resp.error : "Hiba a mentés közben";
      this.service.notiService.open(msg);
    }
  }

  onSaveClick() {
    //if (device.isValid()) {}
    if (this.data.isEdit) {
      this.service.updateAttribute(this.item).subscribe((resp:any) => {
        this.handleResponse(resp);
      })
    } else {
      this.service.createAttribute(this.item, this.data.type).subscribe((resp:any) => {
        this.handleResponse(resp);
      })
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
